import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { serverError } from './../../../../core/models/messages';
import { Component, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastMessage } from './../../../../core/models/chapitreeval';
import { CompanyService } from './../../../../core/services/company/company.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-chapitre-eval',
  templateUrl: './chapitre-eval.component.html',
  styleUrls: ['./chapitre-eval.component.css'],
})
export class ChapitreEvalComponent {
  formchapitre: FormGroup = this.createchapitreForm();
  listchapitre: { name: string; id: number }[] = [];
  esn_id!: string | null;
  currentSortDirection: number = 2;
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems!: number;
  startIndex: number = 0;
  endIndex: number = 5;
  currentSortColumn: string = 'first_name';
  modalRef?: BsModalRef;
  searchForm: FormGroup = this.createSearchForm();
  pagination : boolean =false;

  id!: number;
  idch!: string;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private formBuilder: FormBuilder,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private chapitreservice: CompanyService,
    private spinner: NgxSpinnerService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.esn_id = this.localStorageService.getData('clientConnected');
    this.getListchapitre();
    console.log('liste', this.getListchapitre());
  }
  /* sort data  */
  sortData() {
    let sort = {
      sort: this.currentSortDirection,
      sortAttribute: this.currentSortColumn,
    };
    this.currentSortDirection = this.currentSortDirection === 1 ? 2 : 1;
    this.getListchapitre(sort);
  }

  /* get indexes for pagination */
  getItems(event?: any) {
    if (
      event &&
      (event.startIndex !== this.startIndex ||
        this.endIndex !== event.endIndex ||
        this.itemsPerPage !== event.itemsPerPage ||
        this.currentPage !== event.currentPage)
    ) {
      this.startIndex = event.startIndex;
      this.endIndex = event.endIndex;
      this.itemsPerPage = event.itemsPerPage;
      this.currentPage = event.currentPage;
      if( (this.startIndex !=0 || this.endIndex !=5) || this.pagination == true){        this.pagination = true
      this.getListchapitre();
      }
    }
  }

  createchapitreForm(data?: any) {
    return this.formBuilder.group({
      name: [data && data.name, [Validators.required]],
      esn_id: [this.localStorageService.getData('clientConnected')],
      id: [''],
    });
  }

  toastMessages: ToastMessage = {
    success: 'Ajout de votre chapitre avec succès',
    error: 'Chapitre avec ce nom existe déjà',
  };
  toastMessages1: ToastMessage = {
    success: 'Modifié votre chapitre avec succès',
    error: 'Chapitre avec ce nom existe déjà',
  };
  createChapitre() {
    this.spinner.show();
    this.chapitreservice
      .createchapitreevaluation(this.formchapitre.value)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.getListchapitre();
          this.toastr.success(this.toastMessages.success);
          this.formchapitre.reset();
          this.closeModal();
        },
        error: (err) => {
          this.spinner.hide();
          if (err?.error) {
            if (err.error.message['name']) {
              this.toastr.error(this.toastMessages.error);
            } else {
              this.toastr.error(serverError);
            }
          }
        },
      });
  }
  /* list list esn companies */
  getListchapitre(sort?: any) {
    this.spinner.show();
    let dataPayload = !sort
      ? { per_page: this.itemsPerPage, page: this.currentPage }
      : { ...{ per_page: this.itemsPerPage, page: this.currentPage }, ...sort };
    this.chapitreservice
      .getchapitreList(this.esn_id, dataPayload)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          this.listchapitre = res.data.items.data;
          this.totalItems = res.data.items.total;

          console.log('loggggglist', this.listchapitre);
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  deletechapitre(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Oui, supprimer !',
    }).then((result) => {
      if (result.isConfirmed) {
        this.chapitreservice.deletechapitre(id).subscribe((res: any) => {
          console.log('responce', res);
          Swal.fire(
            'Supprimé !',
            'Chapitre évaluation  a été supprimé.',
            'success'
          );
          this.getListchapitre();
        });
      }
    });
  }

  closeModal() {
    this.formchapitre.reset();
    this.modalRef!.hide();
  }

  /**modifier chapitre evaluation  */

  openModal(template: TemplateRef<any>, data?: any, mode?: string) {
    this.modalRef = this.modalService.show(template, { backdrop: 'static' });

    if (data) {
      this.id = data.id;
      // Ajoutez cette ligne
      this.formchapitre = this.createchapitreForm(data);
    }
  }

  updateIntervenant() {
    console.log('chapitreid', this.formchapitre);
    console.log('this.intervenantId', this.id);
    this.formchapitre.get('id')?.setValue(this.id);

    console.log('chapitreid', this.formchapitre);
    console.log('this.intervenantId', this.id);
    this.formchapitre.get('id')?.setValue(this.id);

    this.chapitreservice
      .updateChapitre(this.id, this.formchapitre.value)
      .subscribe((res: any) => {
        this.toastr.success(this.toastMessages1.success);
        this.closeModal();
        this.getListchapitre();
      });
  }

  /* search chapitre on input */

  createSearchForm(data?: any) {
    return this.formBuilder.group({
      name: [data ? data.name : ''],
    });
  }

  applyFilter(event: any) {
    let filterValue = (event?.target as HTMLInputElement)?.value;
    let esn_id = this.localStorageService.getData('clientConnected');
    let data = {
      per_page: this.itemsPerPage,
      page: this.currentPage,
      sort: this.currentSortDirection,
      search: filterValue,
      esn_id: this.localStorageService.getData('clientConnected'),
      sortAttribute: 'name',
    };
    this.spinner.show();
    this.chapitreservice
      .searchChapitre(esn_id, data)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listchapitre = res.data.items.data.slice(0, this.endIndex);
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  reset() {
    this.searchForm.reset();
    this.searchForm = this.createSearchForm();
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
